import { useState } from 'react';

const State = () => {
  const [activities, setActivities] = useState([]);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    column: 'Name',
    direction: 'asc',
  });

  return {
    activities,
    setActivities,
    query,
    setQuery,
    loading,
    setLoading,
    sortConfig,
    setSortConfig,
  };
};

export default State;
